import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { DataTablesModule } from 'angular-datatables';

// Librerias LA
import { UControlSoliModule } from '@laranda/lib-ucontrol';
import { SysutilModule } from '@laranda/lib-sysutil';

// Parametros
import { environment } from './../../environments/environment';

// Componentes
import { CtrlCasosComponent } from '../core/components/ctrl-casos/ctrl-casos.component';
import { FooterComponent } from '../core/components/footer/footer.component';
import { HeaderComponent } from '../core/components/header/header.component';
import { InicioComponent } from '../core/components/inicio/inicio.component';
import { LoginComponent } from '../core/components/login/login.component';
import { SistemasComponent } from '../core/components/sistemas/sistemas.component';
import { CambiaClaveComponent } from './components/cambia-clave/cambia-clave.component';
import { VisitasClienteComponent } from './components/visitas-cliente/visitas-cliente.component';
import { Error404Component } from './components/error404/error404.component';


// Rutas
import { AppRoutingModule } from '../app-routing.module';

@NgModule({
  declarations: [
    HeaderComponent,
    SistemasComponent,
    InicioComponent,
    CtrlCasosComponent,
    LoginComponent,
    FooterComponent,
    CambiaClaveComponent,
    VisitasClienteComponent,
    Error404Component
  ],
  imports: [
    CommonModule,
    DataTablesModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    SysutilModule,
    UControlSoliModule.forRoot(environment.URL_REST)
  ]
})
export class CoreModule { }
